export default "__VITE_ASSET__DFckj1qQ__"